module.exports = __webpack_public_path__ + "static/media/logo__login.11b4ab9c.svg";